import { Route, Routes } from 'react-router-dom'
import { NotFound } from 'ui/molecules/NotFound'
import { DocumentsList } from './components/DocumentsList/DocumentsList'

export const Documents = () => (
  <Routes>
    <Route path="/:companyId" element={<DocumentsList />} />
    <Route path="/" element={<DocumentsList />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
)
